import type { FlowstackConfig } from '@flowstack/sdk';

/**
 * Flowstack config — sourced from Vite env vars (`VITE_*`).
 *
 * NOTE: Previously this file read `process.env.NEXT_PUBLIC_*` (Next.js
 * convention), which is undefined in a Vite browser bundle. Every fallback
 * triggered — in particular `tenantId` fell back to `'casino-dev'`, which
 * put Google-login users on a non-existent tenant and broke workspace
 * resolution. Using the VITE_ env vars matches what's actually set in
 * `.env.production`, so real values land in the bundle at build time.
 */
export function getFlowstackConfig(): FlowstackConfig {
  const env = (import.meta as any).env ?? {};
  return {
    mode: (env.VITE_FLOWSTACK_MODE as 'mock' | 'production') ?? 'production',
    jwtSecret: env.VITE_FLOWSTACK_JWT_SECRET ?? 'dev-secret',
    passwordSecret: env.VITE_FLOWSTACK_PASSWORD_SECRET ?? 'dev-password-secret',
    tenantId: env.VITE_FLOWSTACK_TENANT_ID ?? 't_6fe54402be43',
    baseUrl: env.VITE_FLOWSTACK_BASE_URL ?? 'https://sage-api.flowstack.fun',
    auth: {
      providers: ['email', 'google'],
      googleClientId: env.VITE_GOOGLE_CLIENT_ID,
    },
  };
}
